import { Grid2 as Grid, Typography } from "@mui/material"
import { getAllSpecializationAreasReq } from "../../../../redux/guest-slices/common.slice"
import InputField1 from "../../../../components/ui/InputField1"
import { Fragment, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import SpecializationAreas from "../../../../components/ui/SpecializationAreas"

function TimeManagement({ errors, files, onChangFun }) {
  const dispatch = useDispatch()
  const [areas, setAreas] = useState([])
  const { specialist } = useSelector(state => state.specialistSlice)

  const handleGetAreas = (filters) => {
    dispatch(getAllSpecializationAreasReq({
      limit: filters?.limit || 10,
      id: "67d90056c2c4d5ab747f8b3c"
    })
    ).unwrap().then((data) => {
      setAreas(data)
    }).catch(() => { })
  }

  useEffect(() => {
    handleGetAreas()

    // eslint-disable-next-line
  }, [])

  return (
    <Fragment>
      <Grid size={12}>
        <InputField1
          type="text"
          errors={errors}
          name="trainingBackground"
          label="Training in Time Management Techniques *"
          placeholder="Enter Training in Time Management Techniques "
          errText="Please enter training in time management techniques"
          defaultValue={specialist?.profile?.trainingBackground || ""}
        />
      </Grid>

      <Grid size={12}>
        <SpecializationAreas
          areas={areas}
          errors={errors}
          onChangFun={onChangFun}
          label="Time Management Techniques *"
          errText="Please select time management techniques"
        />
      </Grid>

      <Grid size={12}>
        <InputField1
          type="textarea"
          errors={errors}
          name="clienteleFocus"
          label="Clientele Focus *"
          errText="Please enter clientele focus"
          placeholder="Describe the types of clients you typically work with, such as professionals, students, executives, etc"
        />
      </Grid>

      <Typography
        color="#7A8A9E"
        fontWeight="500"
        fontStyle="italic"
      >Improve clients' productivity and time management. Detail your techniques and areas of expertise
      </Typography>
    </Fragment>
  )
}

export default TimeManagement